import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '..'; // 在 store/index.ts 中声明的类型
import { Permission } from '../../service/class/Permission';

// 借助 createSlice 创建 reducer、action
const PermissionSlice = createSlice({
    name: 'permission',
    initialState: {
        value: new Array<Permission>(),
    },
    reducers: {
        setPermission: (state, action: PayloadAction<Permission[]>) => {
            state.value = action.payload;
        },
    },
});

// Action Creator 用于执行返回描述如何更新 state 的 Action
export const { setPermission } = PermissionSlice.actions;

// Selector，作为 useSelector 读取数据的函数参数
export const permissionSelector = (state: RootState) => state.permission.value;

// Reducer，真正执行修改 state 的纯函数
export default PermissionSlice.reducer;
